'use client'

import { InputOtp, type InputOtpProps } from '@heroui/input-otp'
import { forwardRef } from 'react'
import { createInput } from './input-factory'

const BaseVerificationInput = forwardRef<
  HTMLInputElement,
  Omit<InputOtpProps, 'length'> & { length?: number }
>(({ length = 6, variant = 'bordered', ...rest }, ref) => {
  return <InputOtp length={length} ref={ref} variant={variant} {...rest} />
})

export const VerificationInput = createInput(BaseVerificationInput, ['label'])
export const FormVerificationInput = createInput(BaseVerificationInput, [
  'form',
  'label',
])
